import { connect } from 'react-redux';
import get from 'lodash/get';
import { bindActionCreators } from 'redux';
import * as accountAction from 'yoda-site-components/lib/actions/AccountAction';
import AnalyticsAction from 'yoda-site-components/lib/actions/AnalyticsAction';
import * as actions from 'yoda-account-components/lib/actions/TrackOrderActions';
import TrackOrderWrapper from './TrackOrderWrapper';

function mapStateToProps(state) {
    return {
        trackOrder: state.trackOrder,
        deviceType: state.context.deviceType ? state.context.deviceType : {},
        featureFlags: state.context.featureFlags,
        messagesTexts: state.context.messagesTexts,
        preferences: state.context.preferences,
        authenticationSuccess:
            state.signInSliderDetails && state.signInSliderDetails.authenticationSuccess,
        createAccountSuccess: get(state.signInSliderDetails, 'createAccount.isSuccess', false),
        headers: state.context.headers,
    };
}

/* istanbul ignore next */
const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
    accountAction: bindActionCreators(accountAction, dispatch),
    redirectAction: bindActionCreators(
        {
            setRedirectUrl: (redirectData) => ({
                type: 'SET_REDIRECT_URL',
                redirectData,
            }),
        },
        dispatch
    ), // todo refactor this -> that should never depend on app-shell
    analyticsAction: bindActionCreators(AnalyticsAction, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(TrackOrderWrapper);
